import React, {Component} from 'react';
import {IconButton, Typography, Button, Slider} from '@material-ui/core';
import {Close as CloseIcon} from '@material-ui/icons';
import {DEFAULT_THEME, APP_TYPES} from '../util/theme';

/**
 * Style & colour configuration panel.
 * Props:
 *   theme        {object}   current theme object
 *   onThemeChange {function} called with the next full theme object on any change
 *   onClose      {function} optional — renders a close button only when provided
 */
class StyleConfigPanel extends Component {
  patch = (partial) => {
    const theme = {...DEFAULT_THEME, ...this.props.theme};
    this.props.onThemeChange({...theme, ...partial});
  };
  patchNode = (appType, color) => {
    const theme = {...DEFAULT_THEME, ...this.props.theme};
    this.patch({node: {...theme.node, [appType]: color}});
  };
  patchEdge = (key, value) => {
    const theme = {...DEFAULT_THEME, ...this.props.theme};
    this.patch({edge: {...theme.edge, [key]: value}});
  };

  render() {
    const theme = {...DEFAULT_THEME, ...this.props.theme};
    return (
      <div className="ln-style-panel" data-testid="style-panel">
        <div className="ln-inspector-head">
          <Typography variant="subtitle1">Style & colours</Typography>
          {this.props.onClose && (
            <IconButton size="small" onClick={this.props.onClose} data-testid="style-close">
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </div>

        <Typography variant="subtitle2">Node colours</Typography>
        {APP_TYPES.map((t) => (
          <label key={t} className="ln-style-row">
            <span>{t}</span>
            <input
              type="color" value={theme.node[t]} data-testid={`color-${t}`}
              onChange={(e) => this.patchNode(t, e.target.value)}
            />
          </label>
        ))}

        <label className="ln-style-row">
          <span>group</span>
          <input type="color" value={theme.group} onChange={(e) => this.patch({group: e.target.value})} />
        </label>

        <Typography variant="subtitle2">Edges</Typography>
        <label className="ln-style-row">
          <span>edge</span>
          <input type="color" value={theme.edge.color} onChange={(e) => this.patchEdge('color', e.target.value)} />
        </label>
        <label className="ln-style-row">
          <span>highlight</span>
          <input type="color" value={theme.edge.highlightColor} onChange={(e) => this.patchEdge('highlightColor', e.target.value)} />
        </label>
        <label className="ln-style-row">
          <span>handles</span>
          <input type="color" value={theme.handle} onChange={(e) => this.patch({handle: e.target.value})} />
        </label>

        <Typography variant="subtitle2">Font size</Typography>
        <Slider
          min={9} max={18} value={theme.fontSize} valueLabelDisplay="auto"
          onChange={(e, v) => this.patch({fontSize: v})}
        />

        <Button size="small" onClick={() => this.props.onThemeChange(DEFAULT_THEME)} data-testid="style-reset">
          Reset to defaults
        </Button>
      </div>
    );
  }
}

export default StyleConfigPanel;
